import React, { useContext, useState, useEffect } from 'react'
import { DistributionContext } from '.';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import BoxInfo from './boxInfo';
import CargoBoxModalStep2 from './cargoBoxModalStep2';
import './style.css'
import { sortTables } from './functionsCore';
import { stringToInt } from './functionsCore';

const ModalStep2 = () => {

    const { state, setState } = useContext(DistributionContext)
    const [allTable, setAlltable] = useState([])
    const [datagridModalStep2, setDatagridModalStep2] = useState({})


    const getColumns = () => {
        const columns = []

        columns.push(
            {
                field: 'aro',
                headerName: 'Aro',
                flex: 0.6,
                cellClassName: () => {
                    return clsx('default-app bold', {
                        selected: true,
                    });
                }
            }
        )

        columns.push(
            {
                field: 'medida',
                headerName: 'Medida',
                flex: 0.8,
                cellClassName: () => {
                    return clsx('default-app bold align-start', {
                        selected: true,
                    });
                }
            }
        )

        for (let i = 0; i < state.columns.length; i++) {
            const column = state.columns[i];


            let includeColumn = true;

            // Só aplica a soma se já houver rows
            if (state.distrA.length > 0) {
                const total = state.distrA.reduce((acc, row) => {
                    const value = row[column];
                    return acc + (typeof value === 'number' ? value : 0);
                }, 0);

                includeColumn = total > 0;
            }

            if (includeColumn) {

                const isVenda = column.includes("Ven");

                columns.push({
                    field: column,
                    headerName: column,
                    flex: 0.5,
                    cellClassName: (params) => {
                        if (isVenda) {
                            // Configuração para VENDA
                            if (params.field === state.selectedFilialVen) {
                                return clsx('super-app ven-tables', { selected: true });
                            } else {
                                return clsx('default-app ven-tables', { selected: true });
                            }
                        } else {
                            // Configuração para ESTOQUE
                            if (params.field === state.selectedFilial) {
                                return clsx('super-app est-tables', { selected: true });
                            } else {
                                return clsx('default-app est-tables', { selected: true });
                            }
                        }
                    },
                });
            }

        }

        columns.push(
            {
                field: 'dispbks',
                headerName: 'BKS Disp',
                flex: 0.5,
                cellClassName: () => {
                    return clsx('default-app dep-bks', {
                        selected: true,
                    });
                }
            }
        )

        columns.push(
            {
                field: state.reservBranch,
                headerName: state.reservBranchName,
                flex: 0.7,
                cellClassName: () => {
                    return clsx('default-app reserv', {
                        selected: true,
                    });
                }
            }
        )

        columns.push({
            field: 'cargo',
            headerName: 'Carga',
            flex: 0.7,
            renderCell: (params) => (
                <Box >
                    <CargoBoxModalStep2 aro={params.row.aro} med={params.row.medida} />
                </Box>
            )
        })





        return columns

    }

    const setRows = () => {
        const lines = [...state.distrA, ...state.distrB]
        const sorted_lines = sortTables(lines)
        setAlltable(sorted_lines)
    }

    const handleColumnVisibilityChange = (params) => {
        setDatagridModalStep2(params)
        const stringColumn = JSON.stringify(params)
        localStorage.setItem('datagrid-modalstep2', stringColumn);
    };

    useEffect(() => {
        setRows()

        const lenTables = state.consolidatedStep4.length
        let totalAB = 0
        for (let i = 1; i <= lenTables; i++) {

            let lines = state.consolidatedStep4.filter(each => each[`table${i}`])[0][`table${i}`]['lines']
            lines.map(each => totalAB += stringToInt(each.cargo))

        }

        setState({ totalAB: totalAB })

        const storedColumns = localStorage.getItem('datagrid-modalstep2');
        if (storedColumns) {
            setDatagridModalStep2(JSON.parse(storedColumns));
        }


    }, [])

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', height: '40rem' }}>

                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>
                    <BoxInfo title={'TOTAL DE PNEUS'} value={state.totalAB} colorBack={'#c60000'} color={'white'} />
                </Box>

                <Box sx={{ width: '100%' }} >
                    <br />
                    <DataGrid
                        rowHeight={state.rowHeight}
                        className='alterned_grid'
                        density='compact'
                        rows={allTable}
                        columns={getColumns()}
                        columnVisibilityModel={datagridModalStep2}
                        onColumnVisibilityModelChange={(newModel) =>
                            handleColumnVisibilityChange(newModel)
                        }
                        sx={{
                            '& .super-app.selected': {
                                fontWeight: '600',
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            '& .default-app.selected': {
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                            maxHeight: "30rem",
                            '& .MuiDataGrid-columnHeaderTitleContainer': {
                                justifyContent: 'center',
                            },

                        }}

                    />
                </Box>


            </Box>
        </>
    )
}

export default ModalStep2